import { Guid } from '@web/utils';
import { AssetImage } from '../../image/enums/asset-image';

export class SlideshowItem {
  public constructor(
    public readonly id: Guid,
    public readonly image: AssetImage,
    public readonly alt: string,
  ) {}
}
